module.exports = __webpack_public_path__ + "img/platform-width.da702a4d.png";